/**
 * iOS shell store-safe copy (App Store 3.1.1 / 3.1.3(a)): no prices, no subscribe calls to action,
 * no pointer to an outside purchase page. Merged into every catalog by translations.js.
 */
const iosStoreI18n = {
  en: {
    'ios.store.accountNote': "Account and membership changes aren't available in this app.",
    'ios.store.libraryKept': "Your playlists, favorites, and listening history are still safe.",
    'ios.store.paymentIssue': "There's a payment problem on this Maestro account.",
    'ios.store.welcomeBack': "Welcome back! Your playlists, favorites, and library are still saved.",
    'ios.store.accessEnded': "Your playlists, favorites, and library are still saved.", 'ios.store.accessEndedTitle': "Your Maestro access has ended",
    'ios.store.signInOnly': "Sign in with your existing Maestro account.",
  },
  es: {
    'ios.store.accountNote': "Los cambios de cuenta y membresía no están disponibles en esta app.",
    'ios.store.libraryKept': "Tus playlists, favoritos e historial de escucha siguen a salvo.",
    'ios.store.paymentIssue': "Hay un problema de pago en esta cuenta de Maestro.",
    'ios.store.welcomeBack': "¡Bienvenido de nuevo! Tus playlists, favoritos y biblioteca siguen guardados.",
    'ios.store.accessEnded': "Tus playlists, favoritos y biblioteca siguen guardados.", 'ios.store.accessEndedTitle': "Tu acceso a Maestro ha terminado",
    'ios.store.signInOnly': "Inicia sesión con tu cuenta de Maestro existente.",
  },
  fr: {
    'ios.store.accountNote': "Les modifications du compte et de l'abonnement ne sont pas disponibles dans cette app.",
    'ios.store.libraryKept': "Vos playlists, favoris et historique d'écoute sont toujours en sécurité.",
    'ios.store.paymentIssue': "Il y a un problème de paiement sur ce compte Maestro.",
    'ios.store.welcomeBack': "Bon retour ! Vos playlists, favoris et bibliothèque sont toujours enregistrés.",
    'ios.store.accessEnded': "Vos playlists, favoris et bibliothèque sont toujours enregistrés.", 'ios.store.accessEndedTitle': "Votre accès à Maestro est terminé",
    'ios.store.signInOnly': "Connectez-vous avec votre compte Maestro existant.",
  },
  de: {
    'ios.store.accountNote': "Konto- und Mitgliedschaftsänderungen sind in dieser App nicht verfügbar.",
    'ios.store.libraryKept': "Ihre Playlists, Favoriten und Ihr Hörverlauf sind weiterhin sicher.",
    'ios.store.paymentIssue': "Bei diesem Maestro-Konto gibt es ein Zahlungsproblem.",
    'ios.store.welcomeBack': "Willkommen zurück! Ihre Playlists, Favoriten und Ihre Bibliothek sind weiterhin gespeichert.",
    'ios.store.accessEnded': "Ihre Playlists, Favoriten und Ihre Bibliothek sind weiterhin gespeichert.", 'ios.store.accessEndedTitle': "Ihr Maestro-Zugang ist beendet",
    'ios.store.signInOnly': "Melden Sie sich mit Ihrem bestehenden Maestro-Konto an.",
  },
  it: {
    'ios.store.accountNote': "Le modifiche all'account e all'abbonamento non sono disponibili in questa app.",
    'ios.store.libraryKept': "Le tue playlist, i preferiti e la cronologia d'ascolto sono ancora al sicuro.",
    'ios.store.paymentIssue': "C'è un problema di pagamento su questo account Maestro.",
    'ios.store.welcomeBack': "Bentornato! Le tue playlist, i preferiti e la libreria sono ancora salvati.",
    'ios.store.accessEnded': "Le tue playlist, i preferiti e la libreria sono ancora salvati.", 'ios.store.accessEndedTitle': "Il tuo accesso a Maestro è terminato",
    'ios.store.signInOnly': "Accedi con il tuo account Maestro esistente.",
  },
  pt: {
    'ios.store.accountNote': "Alterações de conta e assinatura não estão disponíveis neste app.",
    'ios.store.libraryKept': "Suas playlists, favoritos e histórico de audição continuam seguros.",
    'ios.store.paymentIssue': "Há um problema de pagamento nesta conta Maestro.",
    'ios.store.welcomeBack': "Bem-vindo de volta! Suas playlists, favoritos e biblioteca continuam salvos.",
    'ios.store.accessEnded': "Suas playlists, favoritos e biblioteca continuam salvos.", 'ios.store.accessEndedTitle': "Seu acesso ao Maestro terminou",
    'ios.store.signInOnly': "Entre com sua conta Maestro existente.",
  },
  ja: {
    'ios.store.accountNote': "アカウントとメンバーシップの変更はこのアプリでは行えません。",
    'ios.store.libraryKept': "プレイリスト、お気に入り、再生履歴はそのまま保存されています。",
    'ios.store.paymentIssue': "このMaestroアカウントでお支払いに問題があります。",
    'ios.store.welcomeBack': "おかえりなさい！プレイリスト、お気に入り、ライブラリはそのまま保存されています。",
    'ios.store.accessEnded': "プレイリスト、お気に入り、ライブラリはそのまま保存されています。", 'ios.store.accessEndedTitle': "Maestroのご利用期間が終了しました",
    'ios.store.signInOnly': "既存のMaestroアカウントでサインインしてください。",
  },
  ko: {
    'ios.store.accountNote': "계정 및 멤버십 변경은 이 앱에서 할 수 없습니다.",
    'ios.store.libraryKept': "플레이리스트, 즐겨찾기, 감상 기록은 안전하게 보관되어 있습니다.",
    'ios.store.paymentIssue': "이 Maestro 계정에 결제 문제가 있습니다.",
    'ios.store.welcomeBack': "다시 오신 것을 환영합니다! 플레이리스트, 즐겨찾기, 라이브러리가 그대로 저장되어 있습니다.",
    'ios.store.accessEnded': "플레이리스트, 즐겨찾기, 라이브러리가 그대로 저장되어 있습니다.", 'ios.store.accessEndedTitle': "Maestro 이용이 종료되었습니다",
    'ios.store.signInOnly': "기존 Maestro 계정으로 로그인하세요.",
  },
  zh: {
    'ios.store.accountNote': "无法在此应用中更改帐户和会员资格。",
    'ios.store.libraryKept': "你的播放列表、收藏和收听记录仍然安全保存。",
    'ios.store.paymentIssue': "此 Maestro 帐户存在付款问题。",
    'ios.store.welcomeBack': "欢迎回来！你的播放列表、收藏和音乐库仍然保存着。",
    'ios.store.accessEnded': "你的播放列表、收藏和音乐库仍然保存着。", 'ios.store.accessEndedTitle': "你的 Maestro 使用权限已结束",
    'ios.store.signInOnly': "请使用你现有的 Maestro 帐户登录。",
  },
  nl: {
    'ios.store.accountNote': "Account- en lidmaatschapswijzigingen zijn niet beschikbaar in deze app.",
    'ios.store.libraryKept': "Je playlists, favorieten en luistergeschiedenis zijn nog steeds veilig.",
    'ios.store.paymentIssue': "Er is een betalingsprobleem met dit Maestro-account.",
    'ios.store.welcomeBack': "Welkom terug! Je playlists, favorieten en bibliotheek zijn nog steeds bewaard.",
    'ios.store.accessEnded': "Je playlists, favorieten en bibliotheek zijn nog steeds bewaard.", 'ios.store.accessEndedTitle': "Je toegang tot Maestro is beëindigd",
    'ios.store.signInOnly': "Log in met je bestaande Maestro-account.",
  },
  sv: {
    'ios.store.accountNote': "Konto- och medlemskapsändringar är inte tillgängliga i den här appen.",
    'ios.store.libraryKept': "Dina spellistor, favoriter och lyssningshistorik finns kvar.",
    'ios.store.paymentIssue': "Det finns ett betalningsproblem på det här Maestro-kontot.",
    'ios.store.welcomeBack': "Välkommen tillbaka! Dina spellistor, favoriter och ditt bibliotek finns kvar.",
    'ios.store.accessEnded': "Dina spellistor, favoriter och ditt bibliotek finns kvar.", 'ios.store.accessEndedTitle': "Din Maestro-åtkomst har upphört",
    'ios.store.signInOnly': "Logga in med ditt befintliga Maestro-konto.",
  },
};

export default iosStoreI18n;
